import axios from 'axios';

const baseURL = process.env.APP_URL || 'https://production-server.payrollpanda.my/';
const appId = process.env.APP_ID || '1805ffbfeff800bbc2c5e10f720568bd31816aeb';
const timeout = 5000;
const headers = {

};

const instance = axios.create({
    baseURL,
    timeout,
    headers
});

const createBody = (data) => (
    Object.assign({},
        data, {
            _ApplicationId: appId
        }
    )
);

const calculate = (data) => {
    return instance.post('api/PCBCalculator/calculate', createBody(data));
}

const sendPayslip = (data) => {
    return instance.post('api/PCBCalculator/sendPayslip', createBody(data));
}

export default {
    calculate,
    sendPayslip
};



// WEBPACK FOOTER //
// ./src/api.js